import React, { useState } from "react";
import { motion } from "framer-motion";
import imgLeft from "../../images/learning_style/s4.png";
import ProgressBarStyle from "../../components/ProgressBarStyle"; // Tambahkan import Progress Bar

const Style3 = () => {
  // --- 1. DEKLARASI STATE (Pilihan Tunggal) ---
  const [selected, setSelected] = useState(null); 
  const [loading, setLoading] = useState(false);

  // Mengambil student_id yang benar dari localStorage
  const student = JSON.parse(localStorage.getItem("student"));
  const studentId = student?.student_id;

  // --- VALIDASI SESI AWAL ---
  if (!studentId || Number(studentId) <= 0) {
    alert("Student session error or ID missing. Please log in again.");
    window.location.href = "/login";
    return;
  }

  // --- DEKLARASI OPSI ---
  const options = [
    { key: "S3-Q1", label: "Read book, article, handout", preference_id: 9 },
    { key: "S3-Q2", label: "Use examples and applications", preference_id: 10 },
    { key: "S3-Q3", label: "Like to talk things through", preference_id: 11 },
  ];

  // --- 2. FUNGSI toggleSelect (Pilihan Tunggal) ---
  // Diubah ke logika pilihan tunggal
  const toggleSelect = (key) => {
    setSelected(key);
  };

  // --- FUNGSI SAVE TO DATABASE ---
  const saveToDatabase = async () => {
    setLoading(true);

    try {
      // Mencari objek opsi yang sesuai
      const selectedOption = options.find((o) => o.key === selected);

      if (!selectedOption) {
        throw new Error("No valid option selected.");
      }

      // Karena pilihan tunggal, array hanya berisi satu preference_id
      const selectedPreferences = [selectedOption.preference_id]; 
      const nextStep = '4'; // <<< Step berikutnya setelah Style 3

      const body = {
        student_id: Number(studentId),
        style_id: 3, // Style ID untuk kuesioner ini
        preferences: selectedPreferences,
        next_step: nextStep, // DIKIRIM KE BACKEND
      };

      // Menggunakan endpoint dan method yang konsisten
      const res = await fetch("http://localhost:3000/api/learning-style/save", {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      const data = await res.json();
      if (!res.ok) {
        alert(data.message || "Error saving data");
        setLoading(false);
        return;
      }

      // --- UPDATE LOCALSTORAGE (Logika Konsisten) ---
      const currentStudent = JSON.parse(localStorage.getItem("student"));
      
      const updatedStudent = {
        ...currentStudent,
        ls_current_step: data.next_step || nextStep, 
      };
      
      localStorage.setItem("student", JSON.stringify(updatedStudent));
      // ------------------------------------------------

      // Redirect ke kuesioner berikutnya
      window.location.href = "/learning-style/style4"; 
      
    } catch (err) {
      console.error(err);
      alert("Failed to save. Try again.");
      setLoading(false);
    }
  };

  // --- FUNGSI handleNext (Validasi Frontend) ---
  const handleNext = () => {
    // Validasi pilihan tunggal
    if (!selected) { 
      alert("Please select one option.");
      return;
    }
    saveToDatabase();
  };

  return (
    <div className="min-h-screen flex flex-col items-center bg-gradient-to-b from-blue-900 via-blue-700 to-blue-500 text-white px-4 overflow-hidden">
        
      {/* Progress Bar (Konsisten dengan Style 1 & 2) */}
      <div className="w-full max-w-xl mt-6 z-20">
        <ProgressBarStyle step={3} /> 
      </div>
      
      
      <div className="flex flex-col md:flex-row items-start justify-center gap-0 w-full max-w-4xl relative z-10">

        {/* LEFT IMAGE */}
        <motion.img // Tambahkan motion untuk gambar juga (opsional)
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
          src={imgLeft}
          alt="illustration"
          // >>> PERUBAHAN: Tambahkan margin negatif untuk menggeser gambar ke kiri <<<
          // md:-ml-20: Di layar menengah ke atas, geser gambar 5rem ke kiri.
          // md:mr-4: Tambahkan sedikit margin kanan agar konten tidak terlalu rapat.
          className="w-[250px] md:w-[400px] drop-shadow-2xl flex-shrink-0 md:-ml-20 md:mr-4"
        />

        {/* RIGHT CONTENT */}
         <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="flex flex-col flex-1 z-20 mt-4 md:mt-16" // Tambah mt-16 untuk menyeimbangkan vertikal
        >
            <h1 className="text-lg md:text-xl font-normal text-yellow-300 leading-snug text-left drop-shadow-md pl-4 md:pl-0">
             I learn best when using the following method:
          </h1>

          {/* OPTIONS */}
          {/* PERUBAHAN: Tambahkan padding kiri di mobile (pl-4 md:pl-0) */}
          <div className="mt-4 flex flex-col gap-4 pl-4 md:pl-0"> 
            {options.map((opt) => (
              <motion.div
                key={opt.key}
                whileHover={{ scale: 1.02 }}
                // Menggunakan toggleSelect untuk pilihan tunggal
                onClick={() => toggleSelect(opt.key)} 
                className="flex items-center gap-4 cursor-pointer"
              >
                {/* SELECT CIRCLE (Logika Pilihan Tunggal) */}
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center border-4 ${
                    selected === opt.key // Diubah dari selected.includes(opt.key)
                      ? "bg-yellow-300 border-yellow-400 text-blue-900"
                      : "border-yellow-300 text-transparent"
                  }`}
                >
                  {selected === opt.key ? "✓" : ""} 
                </div>

                {/* TEXT BOX */}
                <div className="flex-1 bg-yellow-300 text-green-900 font-medium text-center py-2 rounded-full text-sm md:text-base shadow-md">
                  {opt.label}
                </div>
              </motion.div>
            ))}
          </div>
         </motion.div>
      </div>

      {/* NEXT BUTTON */}
      <motion.button
        whileHover={{ scale: 1.08 }}
        whileTap={{ scale: 0.95 }}
        onClick={handleNext}
        disabled={loading}
        className="mt-8 bg-yellow-300 text-blue-900 font-bold px-12 py-3 rounded-full shadow-lg disabled:bg-gray-400"
      >
        {loading ? "Saving..." : "Next →"}
      </motion.button>

      <p className="absolute bottom-3 text-blue-200 text-xs">
        © 2025 Universitas Terbuka
      </p>
    </div>
  );
};

export default Style3;